<template>
  <div id="memberProfile">
    memberProfilememberProfile
  </div>
</template>

<script>
export default {
  name: 'MemberProfile'
}
</script>
